import { PortableText } from '@portabletext/react'
import { defaultComponents, normaliseEmbeds } from '@lib/portableText'
import clsx from 'clsx'

export const variants = {
  xl: 'lg:prose-xl',
  base: 'lg:prose-base',
}

const Content = ({ content, variant = 'xl' }) => {
  return (
    <div className={clsx('prose-primary-500 prose', variants[variant])}>
      <PortableText
        value={normaliseEmbeds(content)}
        components={defaultComponents}
      />
    </div>
  )
}
export default Content
